<nb-card>
  <nb-card-header>
    <div class="form-inline">
      <ngx-view-time-period
        (periodChange)="selectTime($event)"
        [typeSelected]="'today'"
      ></ngx-view-time-period>

      <nb-form-field>
        <button
          *ngIf="isDelivered"
          nbPrefix
          nbButton
          ghost
          size="small"
          status="danger"
          (click)="removeFilter('isDelivered')"
        >
          <nb-icon icon="close-outline"></nb-icon>
        </button>
        <nb-select
          class="type-select"
          size="small"
          fullWidth
          [(ngModel)]="isDelivered"
          (selectedChange)="summaryReceipt()"
          placeholder="Chọn trạng thái"
        >
          <nb-option value="delivered"> Đã giao</nb-option>
          <nb-option value="delivery"> Chưa giao </nb-option>
        </nb-select>
      </nb-form-field>

      <ngx-view-selection-object
        [shopId]="shopId"
        [title]="'Chọn nhân viên giao hàng'"
        [prefix]=""
        [allowCreate]="false"
        [objectType]="'employee'"
        [objectId]="employeeDeliveryId"
        [objectName]="employeeDeliveryName"
        [objects]="employeesDeliverer"
        (objectChange)="changeEmployee($event)"
      >
      </ngx-view-selection-object>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="table-responsive">
      <ng2-smart-table
        [settings]="settings"
        [source]="source"
        (userRowSelect)="selectedItem($event)"
      >
      </ng2-smart-table>
      <strong class="text-hint">Tổng số: {{ source.count() }}</strong>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <button
      nbButton
      status="success"
      size="small"
      [class.btn-pulse]="submitted"
      (click)="printDelivery()"
    >
      <nb-icon icon="printer-outline"></nb-icon>
      {{ "buttons.print" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
